
export const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 1024 },
    items: 5,
    slidesToSlide: 2,
  },
  desktop: {
    breakpoint: { max: 1024, min: 800 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 800, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const productData = [
  {
    id: 1,
    imageurl:
      "https://www.pageworks.co.uk/client/assets/templates/palas/images/demo/Responsive-Laptop-iPads-iPhone-400x300.jpg",
    name: "my first website.",
    projectLink: "https://dev-musaddik.github.io/musaddik/",
    description:
      "CreatingCreating my first responsive website was an exciting and challenging endeavor."},
  {
    id: 2,
    imageurl:
      "https://mgsmarttech.com/wp-content/uploads/2020/05/Reasons-Why-Everyone-Love-WordPress-for-Website-Development-1140x694-1.jpg",
    name: "my wordpress website",
    projectLink: "https://dev-mdmusaddik.pantheonsite.io/",
    description: "I'm created this website using only mobile phone. i'm spend a lot of time for creating this site (all most six hours)",
  },
  {
    id: 3,
    imageurl:
      "https://cdn.hashnode.com/res/hashnode/image/upload/v1682778016105/2e4240a8-d249-4378-844f-eb4a00c80acb.jpeg?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
    name: "Cube Css Project",
    projectLink: "https://dev-musaddik.github.io/css-project-one/",
    description: "A beautiful Css project . CSS 3D Glowing Cube Animation Effects - Ambient Light Effects",
  },
  {
    id: 4,
    imageurl:
      "https://fullstack-coder.com/wp-content/uploads/2022/03/stopwatch.png",
    name: "Stopwatch Project ",
    projectLink: "https://dev-musaddik.github.io/stopwatch-/",
    description: " is a timepiece designed to measure the amount of time that elapses between its activation and deactivation. A mechanical ",
  },
  { id: 5,
    imageurl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeIRp8Ut1lXF02e6YT7Rs1BVA_N8e1aA0XJg&usqp=CAU",
    name: "PasswordChecker ",
    projectLink: "https://dev-musaddik.github.io/PasswordChecker/",
    description: "It is important to choose passwords wisely. Check how strong and secure is your password. Improve the strength of your password to stay safe.",
  },
  {
    id: 6,
    imageurl:
      "https://www.interviewbit.com/blog/wp-content/uploads/2022/01/html-projects-800x431.jpg",
    name: "Friend Love Money?",
    projectLink: "https://dev-musaddik.github.io/relationship-between-frinds-love-money/",
    description: "The title of this volume is aptly Love, Money and Friendships.",
  },
  
   
  {
    id: 7,
    imageurl:
      "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200121234029/Top-10-Projects-For-Beginners-To-Practice-HTML-and-CSS-Skills.jpg",
    name: "My bank project",
    projectLink: "https://dev-musaddik.github.io/MusaddikBank/",
    description: "A web application used to tranfer virtual money between multiple users and also record the banking transactions",
  },
  {
    id: 8,
    imageurl:
      "https://adminapi.applegadgetsbd.com/storage/media/large/iPhone-14-Pro-Max-9907.jpg",
    name: "My iphone project",
    projectLink: "https://dev-musaddik.github.io/iphones/",
    description: "I'm going to create an Apple iPhone like User Interface (UI) design using HTML and CSS.",
  },
];
